import {
  PostProjectByProjectIdIssuesOnBoardsApiArg,
  PostProjectByProjectIdIssuesOnBoardsApiResponse,
} from "../../../../../openapi";
import { trpcSlice } from "../../../../trpcSlice";

export const multiRegisterIssuesApi = trpcSlice.injectEndpoints({
  endpoints: (build) => ({
    getMultiRegisterIssuesOnBoards: build.query<
      PostProjectByProjectIdIssuesOnBoardsApiResponse,
      PostProjectByProjectIdIssuesOnBoardsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues-on-boards`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
  }),
});

export const { useGetMultiRegisterIssuesOnBoardsQuery } = multiRegisterIssuesApi;
